import { NEWBUILDING_KPN_CHAT } from 'node/services/fetchExperiments/getExperiments';

// eslint-disable-next-line import/no-cycle
import { NEWBUILDING_TRUST_AND_SAFETY, CPD_LABEL_EXPERIMENT } from 'shared/selectors/abExperiments';

export const EXPERT_OPINION = 'aud_desktop_bx495_expert_opinion_gpt_newb';

export const EXPERIMENTS: string[] = [
  NEWBUILDING_TRUST_AND_SAFETY,
  EXPERT_OPINION,
  CPD_LABEL_EXPERIMENT,
  NEWBUILDING_KPN_CHAT,
];
